import httpRequest from "../../../infrastructure/httphelper";
import { downloadBlob } from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";
import * as constants from '../constants';

class MICustomerSharedService {
  constructor() { }

  getMICustomerMasters() {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetMICustomerMasters";
    return httpRequest({
      url: url,
      method: "GET",
    });
  }

  saveNewEnquiry(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/NewEnquiry";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload,
    });
  }

  saveMemberBasicInfo(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveMembersInfo";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload,
    });
  }
 validateSaveMemberBasicInfo(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/ValidateSaveMemberBasicInfo";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload,
    });
  }

  getInsuredInformationMasters() {
    let url = sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/GetInsuredInformationMasters";
    return httpRequest({
      url: url,
      method: "POST",
      data: 0,
    });
  }
  // getProductsByProductType(productTypeId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/GroupQuotation/GetProductsByProductType";
  //   let para = {
  //     productTypeId: productTypeId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  getStatusMaster(stageId, moduleType) {
    let url = sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/GetStatusMaster";
    let para = {
      stageId: stageId,
      moduleType: moduleType,
    }
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      params: para
    });
  }
  // GetAgentMasterByBusinessType(businessType, branchId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetAgentMasterByBusinessTypeAndBranch";
  //   let para = {
  //     businessType: businessType,
  //     branchId: branchId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para
  //   });
  // }
  // getSearchPolicyInformation(searchParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPolicySearchResults";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,

  //   });
  // }
  // searchPartyMaster(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SearchPartyMaster";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // searchPartyMasterByPartyCode(policyNo) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SearchPartyMasterByPartyCode";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: policyNo,
  //   });
  // }
  // getEndorsementsByDocumentId(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetEndorsementsByDocumentId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  getInsuredCodesByName(params) {
    let url =
      sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/SearchInsuredCodesByName";
    return httpRequest({
      url: url,
      method: "POST",
      data: params,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  // savePolicyInformation(savePolicyInfo) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SavePolicyInformation2";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: savePolicyInfo
  //   });
  // }
  getInsuredInformation(insuredCode, insuredTransId) {
    let url =
      sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/GetInsuredInformation2";
    let parameters = {
      insuredCode: insuredCode,
      insuredTransId: insuredTransId
    }
    return httpRequest({
      url: url,
      method: "POST",
      params: parameters,
    });
  }
  // getProspectInformation(prospectCode) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetProspectInformation";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: prospectCode,
  //   });
  // }
  // getCurrentPolicyInformation(policyNo, endorsementNo) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCurrentPolicyInformation2";
  //   let para = {
  //     policyNo: policyNo,
  //     endorsementNo: endorsementNo
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para
  //   });
  // }

  // getCategoryDetailsByProposal(quotationId, proposalId, documentId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetConfirmationCategoryDetails"; // changed by Shaher yar  to get premium
  //   // sharedGlobals.appUrls.miCoreApiUrl + "api/GroupQuotation/GetConfirmationCategoryDetails";
  //   let para = {
  //     quotationId: quotationId,
  //     proposalId: proposalId,
  //     documentId: documentId,
  //     endorsementId: endorsementId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getPolicyTOBMaster(documentId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPolicyTOBMaster";
  //   let para = {
  //     documentId: documentId,
  //     endorsementId: endorsementId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getCategoryMasters() {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/GroupQuotation/getCategoryMasters";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //   });
  // }
  // getPolicyLoadingDistribution(documentId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPolicyLoadingDistribution";
  //   let para = {
  //     documentId: documentId,
  //     endorsementId: endorsementId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getPolicyBaseBenefitMaster(documentId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPolicyBaseBenefitMaster";
  //   let para = {
  //     documentId: documentId,
  //     endorsementId: endorsementId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getPolicyCostingSheet(documentId, proposalId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPolicyCostingSheet";
  //   let para = {
  //     documentId: documentId,
  //     proposalId: proposalId,
  //     endorsementId: endorsementId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // createEndorsement(searchParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CreateEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,

  //   });
  // }
  // saveEndorsementInformation(searchParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveEndorsementInformation";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,

  //   });
  // }
  updateInsuredInformationById(params) {
    let url = sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/UpdateInsuredInformationById2";
    return httpRequest({
      url: url,
      method: "POST",
      data: params
    });
  }
  // getPolicySummary(documentId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPolicySummary2";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: documentId
  //   });
  // }
  // getMemberPremiumDetails(memberPremiumDetails) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetMemberPremiumDetails2";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: memberPremiumDetails
  //   });
  // }


  /******* Member Page *******/
  // getMembers(searchParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/getMembers2";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,
  //   });
  // }
  // getMemberDetails(memberInfo) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetMemberDetails2";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: memberInfo
  //   });
  // }
  getLocationMaster(emirate) {
    let url = sharedGlobals.appUrls.miCustomerApiUrl + `api/MICustomer/GetLocationMaster?emirateId=${emirate}`;
    return httpRequest({
      url: url,
      method: "GET",
      // dataType: 'json',
      // data: emirate
    });
  }
  // saveMemberDetails(saveMemberInfo) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveMemberDetails2";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: saveMemberInfo
  //   });
  // }
  // getPrincipalMasters(parameter) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPrincipalMasters";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: parameter,
  //   });
  // }
  // getRelationMasters(relationParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetRelationMasters";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: relationParams,
  //   });
  // }
  // deleteMembers(deleteParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DeleteMembers";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: deleteParams,
  //   });
  // }

  /*****Documents Tab *****/
  downloadFile(encryptedId) {
    let url = sharedGlobals.appUrls.insSharedApiUrl + 'api/InsShared/DownloadDocument?encryptedId=' + encodeURIComponent(encryptedId);
    window.open(url);
  }
  // getPolicyDocumentList(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetDocumentList";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // getMemberDocumentList(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetDocumentList";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // getDocumentMasters(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetDocumentMasters";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // saveDocuments(saveDoc) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveDocuments";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: saveDoc
  //   });
  // }
  // getMemberDependents(searchParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/getDependentsByPrincipalId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,
  //   });
  // }
  getUserMasters() {
    let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserMasters";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
    });
  }
  // getUserMastersByGroup(groupId) {


  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/WorkAssignment/GetUserMastersByGroup";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: groupId
  //     // data: moduleId,
  //   });
  // }
  getCashierMasters() {
    let url = sharedGlobals.appUrls.securityApiUrl + "api/Security/GetCashiresMasters";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
    });
  }
  /*getCurrentEndorsementDetail(documentId, endorsementId) {
    let url =
      sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCurrentEndorsementDetail";
    let para = {
      documentId: documentId,
      endorsementId: endorsementId
    }
    return httpRequest({
      url: url,
      method: "POST",
      params: para,
    });
  }*/
  // savePolicySummaryInformation(TPAfeeParams) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SavePolicySummaryInformation";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: TPAfeeParams
  //   });
  // }
  // deleteEndorsement(endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DeleteEndorsement";
  //   let para = {
  //     endorsementId: endorsementId,

  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getEndorsementQuotation(endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetEndorsementQuotation";
  //   let para = {
  //     endorsementId: endorsementId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // approveEndorsement(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ApproveEndorsement";
  //   // let para = {
  //   //   endorsementId: endorsementId,
  //   // }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getRegulatoryByEmirate(emirateId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetRegulatoryByEmirate";
  //   let para = {
  //     emirateId: emirateId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }

  // approvePolicy(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ApprovePolicy";
  //   // let para = {
  //   //   policyId: policyId,
  //   // }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // uploadExcelFile(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ValidateImportedMemberData";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // downloadExcelTemplatesWithError(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DownloadTemplateDataWithErrors";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // importMemberData(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ImportPolicyMemberData";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveRegulatoryIntegrationBatch(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/SaveRegulatoryIntegrationBatch";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // getVerificationBatchListing(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetVerificationBatchListing";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // exportVerificationBatchListing(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/ExportVerificationBatchListing";
  //   return downloadBlob({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //     saveAsFileName: 'intergrationexport.csv'
  //   });
  // }
  // getBatchDetailsByBatchId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetBatchDetailsByBatchId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // getDHABatchDetailsByBatchId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetDHABatchDetailsByBatchId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // getDOHMemberDetailsByMemberId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetDOHMemberDetailsByMemberId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }

  // saveDOHMemberDetails(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/SaveDOHMemberDetails";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveDHAMemberDetails(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/SaveDHAMemberDetails";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }

  // getDHAMemberDetailsByMemberId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetDHAMemberDetailsByMemberId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // saveDohForceTransaction(params) {
  //   console.log("params sr", params)
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/SaveDohForceTransaction";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // updateBatchStatusToQueued(params) {
  //   console.log("params sr", params)
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/UpdateBatchStatusToQueued";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //     dataType: null
  //   });
  // }
  // getFilteredMembers(filterParams) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetFilteredMembers";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: filterParams,
  //   });
  // }
  // calculateHAADPenalty(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CalculateHAADPenalty";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // checkMemberPremiumForCategoryChange(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CheckMemberPremiumForCategoryChange";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // uploadMedicalCardNumbersBatchExcelFile(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/UploadMedicalCardNumbersBatch";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // downloadTemplates(section) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/DownloadTemplates";
  //   let para = {
  //     section: section,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getInstallmentPremium(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetInstallmentPremium";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveInstallements(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveInstallmentPremium";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // recalulateInstallments(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveAndCalculateInstallmentPremium";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // getInstallmentPremiumForEndorsement(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetInstallmentPremiumForEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveInstallementsForEndorsement(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveInstallmentPremiumForEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // recalulateInstallmentsForEndorsement(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveAndCalculateInstallmentPremiumForEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // recalculateSubgroupBilling(policyId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CalculateSubgroupBilling";
  //   let para = {
  //     policyId: policyId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // recalculateSubgroupBillingForEndorsement(endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CalculateSubgroupBillingForEndorsement";
  //   let para = {
  //     endorsementId: endorsementId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }

  // getSubgroupBilling(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetSubgroupBilling";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveSubgroupBilling(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveSubgroupBilling";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveSubgroupBillingEndorsement(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveSubgroupBillingEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // deleteSubgroupBilling(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DeleteSubgroupBilling";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // getSubgroupMasters(policyId, endorsementId, memberId, isMemberSubgroupNull) {
  //   let para = {
  //     policyId: policyId,
  //     endorsementId: endorsementId,
  //     memberId: memberId,
  //     isMemberSubgroupNull: isMemberSubgroupNull
  //   }
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/getSubgroupMasters";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getVatRateAndPercMaster(policyId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetVatRateAndPercMaster";
  //   let para = {
  //     policyId: policyId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getCommunicationValues(quotationId, policyId, endorsementId) {
  //   let para = {
  //     quotationId: quotationId,
  //     policyId: policyId,
  //     endorsementId: endorsementId
  //   }
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetCommunicationValues";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // saveCommunicationValues(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/SaveCommunicationValues";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // getRemarksValues(quotationId, policyId, endorsementId) {
  //   let para = {
  //     quotationId: quotationId,
  //     policyId: policyId,
  //     endorsementId: endorsementId
  //   }
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetRemarksValues";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getPremiumBifurcation(memberId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetPremiumBifurcation";
  //   let para = {
  //     memberId: memberId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getPremiumBifurcationForPolicy(memberId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPremiumBifurcation";
  //   let para = {
  //     memberId: memberId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // saveRemarksValues(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/SaveRemarksValues";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // deletePolicyChargeByChargeId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DeletePolicyChargeByChargeId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // validateSummaryCharges(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ValidateSummaryCharges";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  getMaster(stageId, moduleType) {
    let url = sharedGlobals.appUrls.insSharedApiUrl + "api/InsShared/GetStatusMaster";
    let para = {
      stageId: stageId,
      moduleType: moduleType,
    }
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      params: para
    });
  }
  // getCheckList(policyId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCheckList";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: policyId,
  //   });
  // }
  // saveCheckList(param) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveCheckList";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param,
  //   });
  // }

  // onApproveRequest(endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ApproveEndorsementRequest";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: endorsementId,
  //   });
  // }
  // searchPolicyForMemberUi(param) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SearchPolicyForMemberUi";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param
  //   });
  // }
  // validateTPADownloadExcel(param) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ValidateTPADownloadExcel";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param
  //   });
  // }
  // validateCostingSheetExcel(param) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ValidateCostingSheetExcel";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param
  //   });
  // }
  // getMemberSearchDownloadExcel(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetMemberSearchDownloadExcel"
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param
  //   });

  // }
  // saveStageStatus(policyId, endorsementId, stage, status) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveStageStatus";
  //   let paras = {
  //     policyId: policyId,
  //     endorsementId: endorsementId,
  //     stage: stage,
  //     status: status
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: paras
  //   });
  // }


  // createOnlinePayment(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/CreateOnlinePayment";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // CreatePaymentTranForPaymentLink(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/CreatePaymentTranForPaymentLink";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params
  //   });
  // }
  // getPaymentLink(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetPaymentLink";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // getPaymentInformation(linkId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetPaymentInformation";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: linkId
  //   });
  // }
  // getPaymentInformationByEncryptedReferenceId(referenceId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetPaymentInformationByEncryptedReferenceId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: referenceId
  //   });
  // }
  // reCalculateEntirePolicyPremium(documentId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ReCalculateEntirePolicyPremium";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: documentId
  //   });
  // }
  // savePaymentTransaction(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/SavePaymentTransaction";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // getApprovalInformation(policyId, endorsementId) {
  //   let para = {
  //     policyId: policyId,
  //     endorsementId: endorsementId
  //   }
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetApprovePolicyAndEndorsementInformation";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // validatePolicyNoMemberSearch(policyNo) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ValidatePolicyNoMemberSearch?policyNo=" + policyNo;
  //   return httpRequest({
  //     url: url,
  //     method: "GET",

  //   });
  // }
  // validateCensusData(param) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ValidateCensusData?policyNo=" + param;
  //   return httpRequest({
  //     url: url,
  //     method: "GET",

  //   });
  // }
  // getCensusDownloadExcel(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCensusDownloadExcel"

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param,
  //   });
  // }
  ///cardbatch & print ////////////////////
  // getSearchCardMembersInformation(searchParams) {
  //   console.log('searchTest', searchParams)
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCardPrintBatch";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,

  //   })
  // }
  // getCategorybyPolicy(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetBatchPolicyCategoryByDocId?id=" + param;
  //   return httpRequest({
  //     url: url,
  //     method: "GET",
  //     dataType: 'json',
  //     data: param,
  //   })
  // }
  // getEndorsementbyPolicy(param) {
  //   debugger
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetBatchPolicyEndorsementById?id=" + param;
  //   return httpRequest({
  //     url: url,
  //     method: "GET",
  //     dataType: 'json',

  //   })
  // }
  // getSubgroupbyPolicy(param) {
  //   debugger
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetBatchPolicySubGrouptById?id=" + param;
  //   return httpRequest({
  //     url: url,
  //     method: "GET",
  //     dataType: 'json',
  //   })
  // }
  // getcreateCardPrintBatch(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CreateCardPrintBatch";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: param,
  //   })
  // }
  // getCardBatchSubmit(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCardBatchSubmit"

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param
  //   });
  // }
  // getStatusOfCardsForBatch(batchIds) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetStatusOfCardsForBatch"

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: batchIds
  //   });
  // }
  // getCardPrintPostman(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CardPrintPostman"

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param
  //   });
  // }
  ///cardbatch & print ////////////////////

  // getExportReportByDate(param) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetExportReportByDate"

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param,
  //   });
  // }
  // saveMemberPhoto(memberId, fileEncryptedId) {
  //   let para = {
  //     memberId: memberId,
  //     fileEncryptedId: fileEncryptedId
  //   }
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveMemberPhoto";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getNasbatchDetailsBybatchId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetNasbatchDetails";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // changeProduct(quotationId, newVisaEmirate, newProduct, newPlan, moduleId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/CopyQuotation";
  //   let paras = {
  //     quotationId: quotationId,
  //     newVisaEmirate: newVisaEmirate,
  //     newProduct: newProduct,
  //     newPlan: newPlan,
  //     moduleId: moduleId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: paras
  //   });
  // }
  // getVisaEmirates() {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetVisaEmirates";

  //   return httpRequest({
  //     url: url,
  //     method: "GET",
  //   });
  // }
  // getProductsByVisaEmirateId(visaEmiratesId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetProductsByVisaEmirateId";
  //   let para = {
  //     visaEmiratesId: visaEmiratesId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // changePlan(quotationId, newPlan, moduleId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/CopyQuotation";
  //   let paras = {
  //     quotationId: quotationId,
  //     newPlan: newPlan,
  //     moduleId: moduleId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: paras
  //   });
  // }

  // getNasMemberDetails(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetNasMemberDetail";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // updateNasRecordInMembersTable(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/UpdateNasRecordInMembersTable";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }

  // getTaxMasters(productId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetTaxMasterByProductId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: productId,
  //   });
  // }

  // updateInsuredInformationInPolicy(params) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/UpdateInsuredInformationInPolicy";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }

  // /*Job Assignment Medical Portal */
  // createJobAssignment(params) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/WorkAssignment/CreateAssignTask";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // validateTaskUserAccess(documentId, moduleId, systemId) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/WorkAssignment/ValidateTaskUserAccess?documentId=" + documentId + "&moduleId=" + moduleId + "&systemId=" + systemId;

  //   return httpRequest({
  //     url: url,
  //     method: "GET",
  //   });
  // }
  // getTaskAssignUsers(moduleId, systemId, isSelf) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/WorkAssignment/GetTaskAssignUsers";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: {
  //       moduleId: moduleId,
  //       systemId: systemId,
  //       isSelf: isSelf
  //     }
  //   });
  // }
  /*Job Assignment Medical Portal */
  /*Job Assignment Policy and Endorsement*/
  // getEndorsementsToBeAssigned(params) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetEndorsementsToBeAssigned";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }

  // /*Job Assignment*/
  // /*documents listing*/
  // getUnPostedDocumentsByModule(params) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetUnPostedDocumentsByModule";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  // /*documents listing*/
  // getCustomTariffRates(documentId, categoryId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCostingSheetForMigratedPolicies";
  //   let para = {
  //     documentId: documentId,
  //     categoryId: categoryId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // getCategoriesListFromTobByDocumentId(documentId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCategoriesListFromTobByDocumentId";
  //   let para = {
  //     documentId: documentId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // savePricingTariffSheet(values) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveCostingSheetForMigratedPolicies";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: values,
  //   });
  // }

  // /*Job Assignment Medical Portal */
  // /*Job Assignment Policy and Endorsement*/
  // getEndorsementsToBeAssigned(params) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetEndorsementsToBeAssigned";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }
  /*Job Assignment Policy and Endorsement*/
  /////addition of subgroup endorsement///
  // deleteSubgroupBillingForEndorsement(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DeleteSubgroupBillingForEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }
  // saveSubgroupBillingEndorsement(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveSubgroupBillingEndorsement";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }

  /////addition of subgroup endorsement///

  // getCOCbatchDetailsBybatchId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetCOCbatchDetails";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }

  // saveCOCRegulatoryIntegrationBatch(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/SaveCOCRegulatoryIntegrationBatch";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }


  // saveCategories(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveEndorsementCategories";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }

  // getBenefitStructureByDocument(documentId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/getBenefitStructureByDocument";
  //   let para = {
  //     documentId: documentId,
  //     endorsementId: endorsementId
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }

  // getPlanBenefitsByEndorsementId(endorsementId, policyId, productType, tpaId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetPlanBenefitsByEndorsementId";
  //   let para = {
  //     endorsementId: endorsementId,
  //     documentId: policyId,
  //     productType: productType,
  //     tpaId: tpaId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }

  // getBenefitsByPlan(planId, documentId, categoryId, endorsementId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetBenefitsByPlan";
  //   let para = {

  //     planId: planId,
  //     categoryId: categoryId,
  //     documentId: documentId,
  //     endorsementId: endorsementId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }

  // saveLoadingDistribution(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveEndorsementLoadingDistribution";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }


  // deleteLoadingInformation(loadingDataToDelete) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/DeleteLoadingInformation";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: loadingDataToDelete,
  //   });
  // }


  // saveBenefitStructurePlans(benefitStructureDto) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveBenefitStructurePlans";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: benefitStructureDto,
  //   });
  // }

  // getChildBenefitValuesByParent(params1) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/GroupQuotation/GetChildBenefitValuesByParent";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params1,
  //   });
  // }


  // getBenefitPlanByCustomParameters(visaRegionId, networkId, opCoInsuranceId, dentalId, opticalId, tpaId, pharCoId, remarksId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/GroupQuotation/GetBenefitPlanByCustomParameters";

  //   let paraaa = {
  //     opCoInsuranceId: opCoInsuranceId,
  //     networkId: networkId,
  //     visaRegionId: visaRegionId,
  //     dentalId: dentalId,
  //     opticalId: opticalId,
  //     tpaId: tpaId,
  //     pharCoId: pharCoId,
  //     remarksId: remarksId

  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: paraaa,
  //   });
  // }


  // getCustomTariffRatesForEndorsement(documentId, endorsementId, categoryId) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetCustomTariffRates";
  //   let para = {
  //     documentId: documentId,
  //     endorsementId: endorsementId,
  //     categoryId: categoryId,
  //   }
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }


  // savePricingTariffSheetForEndorsement(values) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveCustomTariffRates";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: values,
  //   });
  // }


  // saveCustomPropertyValue(param) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SaveCustomPropertyValue";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: param,
  //   });
  // }
  // onCreateShafafiyaBatch(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CreateShafafiyaBatchforMigratedPolicies";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }

  // GetPersonInsuranceHistory(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MICore/GetPersonInsuranceHistory";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }
  // cancelCOC(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/CancelCOC";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params,
  //   });
  // }

  // GetICPMemberBatchDetails(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetICPMemberBatchDetails";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }


  // getICPPolicyBatchDetailsByBatchId(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GetICPPolicyBatchDetailsByBatchId";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: params,
  //   });
  // }

  // /*Group Renewal*/

  // getGroupRenewalSearchInformation(searchParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetGroupRenewalSearchResults";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     data: searchParams,

  //   });
  // }


  // renewGroupPolicy(policyId) {
  //   let para = {
  //     policyId: policyId,
  //   }
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/GroupQuotation/RenewGroupPolicy";

  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     params: para,

  //   });
  // }
  // generateCOCReferenceNumberOnDeletion(para) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/MiCore/GenerateCOCReferenceNumberOnDeletion";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     dataType: 'json',
  //     params: para,

  //   });
  // }


  // reinstateMembers(deleteParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ReinstateMembers";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: deleteParams,
  //   });
  // }
  // uploadICPManually(deleteParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/uploadICPManually";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: deleteParams,
  //   });
  // }


  // SearchPartyMasterWithBranches(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SearchPartyMasterWithBranches";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // createNASUploadBatchForIndividualPolicies(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/CreateNASUploadBatchForIndividualPolicies";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }

  // searchPartyMaster(para) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/SearchPartyMaster";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     params: para,
  //   });
  // }
  // reinstateMembers(deleteParams) {
  //   let url = sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/ReinstateMembers";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: deleteParams,
  //   });
  // }
  // getMedicalOldAgeCutOffDate() {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Policy/GetMedicalOldAgeCutOffDate";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //   });
  // }
  getAllTreatyProductLink() {
    let url =
      sharedGlobals.appUrls.riCoreApiUrl + "api/RICore/GetAllTreatyProductLink";
    return httpRequest({
      url: url,
      method: "POST",
    });
  }
  getProductPlanByVisaEmirateIdForIndicativeQuote(visaEmirateId, enquiryNo, encryptedEnquiryRefId1, encryptedEnquiryRefId2, newtworkId = 0) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetProductPlanByVisaEmirateIdForIndicativeQuote";

    return httpRequest({
      url: url,
      method: "GET",
      params: { visaEmirateId, enquiryNo, encryptedEnquiryRefId1, encryptedEnquiryRefId2, newtworkId }
    });
  }
  savePlanDetails(request) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SavePlanDetails";

    return httpRequest({
      url: url,
      method: "POST",
      data: request,
    });
  }
  validateSavePlanDetails(request) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/ValidateSavePlanDetails";

    return httpRequest({
      url: url,
      method: "POST",
      data: request,
    });
  }

  getMembersBasePremiumByPlan(planId, productId, enquiryId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetMembersBasePremiumByPlan?planId=" + planId + "&productId=" + productId + "&enquiryId=" + enquiryId;

    return httpRequest({
      url: url,
      method: "GET",
    });
  }

  getProductPlanTOBByPlanId(planId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetProductPlanTOBByPlanId?planId=" + planId;
    return httpRequest({
      url: url,
      method: "GET"
    });
  }

  getMafQuestions(productId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetMafQuestions?productId=" + productId;
    return httpRequest({
      url: url,
      method: "GET",
    });
  }
  saveMedicalFormDetails(saveMedicalFormDetails) {
    let url = sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveMedicalFormDetails";
    return httpRequest({
      url: url,
      method: "POST",
      dataType: 'json',
      data: saveMedicalFormDetails
    });
  }
  createOnlinePayment(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/CreateOnlinePayment";
    return httpRequest({
      url: url,
      method: "POST",
      data: params
    });
  }
  getQuoteMembers(encryptedEnquiryRefId1, encryptedEnquiryRefId2) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + `api/MICustomer/GetQuoteMembers`;
    return httpRequest({
      url: url,
      method: "GET",
      params: { encryptedEnquiryRefId1, encryptedEnquiryRefId2 }
    });
  }
  getPaymentInformationByEncryptedReferenceId(referenceId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetPaymentInformationByEncryptedReferenceId";
    return httpRequest({
      url: url,
      method: "POST",
      data: referenceId
    });
  }

  getBenefitStructureByPlanIds(planIds) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetBenefitStructureByPlanIds";
    return httpRequest({
      url: url,
      method: "POST",
      data: planIds
    });
  }
  getReportUrl(reportContext) {
    const url = sharedGlobals.appUrls.reportManagerApiUrl + `api/ReportEngineService/GetReportUrlInternal?apiKey=${constants.REPMANAGER_APIKEY}`;
    return httpRequest({
      url: url,
      method: 'POST',
      data: reportContext,
    });
  }
  getQuoteSearchResult(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetQuoteSearch";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload
    });
  }

  getQuotationDocumentMasters(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetQuotationDocumentMasters";
    return httpRequest({
      url: url,
      method: "POST",
      data: params
    });
  }
  getMembersByQuoteId(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + `api/MICustomer/GetMembersByQuoteId`;
    return httpRequest({
      url: url,
      method: "GET",
      params: params
    });
  }

  // getQuoteDocumentList(params) {
  //   let url =
  //     sharedGlobals.appUrls.miCoreApiUrl + "api/Quotation/GetDocumentList";
  //   return httpRequest({
  //     url: url,
  //     method: "POST",
  //     data: params
  //   });
  // }

  saveProspectDetails(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveProspectDetails";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload,
    });
  }

validateUpdateQuoteMember(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/ValidateUpdateQuoteMember";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload,
    });
  }

  updateQuoteMember(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/UpdateQuoteMember";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload,
    });
  }

  getQuoteInformation(encryptedEnquiryRefId1, encryptedEnquiryRefId2) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + `api/MICustomer/GetQuotebyRefIds`;
    return httpRequest({
      url: url,
      method: "GET",
      params: { encryptedEnquiryRefId1, encryptedEnquiryRefId2 },
    });
  }

  saveMemberDocuments(saveDoc) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveDocuments";
    return httpRequest({
      url: url,
      method: "POST",
      data: saveDoc
    });
  }

  getQuoteDocuments(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetDocumentList";
    return httpRequest({
      url: url,
      method: "POST",
      data: params
    });
  }

  getPremiumSummary(encryptedEnquiryRefId1, encryptedEnquiryRefId2) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetPremiumSummary";
    return httpRequest({
      url: url,
      method: "POST",
      params: { encryptedEnquiryRefId1, encryptedEnquiryRefId2 },
    });
  }
  getMafAnswers(encryptedEnquiryRefId1, encryptedEnquiryRefId2) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetMafAnswers";
    return httpRequest({
      url: url,
      method: "GET",
      params: { encryptedEnquiryRefId1, encryptedEnquiryRefId2 }
    });
  }
  processCOCBatchOnApprovals(quotationId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/ProcessCOCBatchOnApprovals";
    return httpRequest({
      url: url,
      method: "POST",
      params: quotationId,
    });
  }

  getFilteredNetworks(encryptedEnquiryRefId1, encryptedEnquiryRefId2) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetFilteredNetworks";
    return httpRequest({
      url: url,
      method: "GET",
      params: { encryptedEnquiryRefId1, encryptedEnquiryRefId2 }
    });
  }



  addUaePassLogApi(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/UaePassLogAuthCode";
    return httpRequest({
      url: url,
      method: "POST",
      data: payload
    });
  }
  getPlanTypebyNetworkId(payload) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + `api/MICustomer/GetPlanTypeByNetworkId?networkId=${payload}`;
    return httpRequest({
      url: url,
      method: "GET"
    });
  }
  deleteMember(memberId) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + `api/MICustomer/DeleteMemberInformation?memberId=${memberId}`;
    return httpRequest({
      url: url,
      method: "GET"
    });
  }
  getCustomerInformationById(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/GetCustomerInformationById";
    return httpRequest({
      url: url,
      method: "POST",
      params: params,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  customerInsuredInformationSave(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveCustomerV1";
    return httpRequest({
      url: url,
      method: "POST",
      data: params,
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  saveTermsAndConditionsResponse(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveTermsAndConditionsResponse";
    return httpRequest({
      url: url,
      method: "POST",
      params: params,
    });
  }
  saveCustomerConfirmation(params) {
    let url =
      sharedGlobals.appUrls.miCustomerApiUrl + "api/MICustomer/SaveCustomerConfirmation";
    return httpRequest({
      url: url,
      method: "POST",
      params: params,
    });
  }
}







let instance = new MICustomerSharedService();
export default instance; 